import styled from 'styled-components';
import { Box } from '../../../Box';
export var StyledTable = styled(Box).attrs({
  as: 'table'
}).withConfig({
  displayName: "styled__StyledTable",
  componentId: "sc-c6z9ks-0"
})(["display:table;border-collapse:separate;border-spacing:0;width:100%;"]);